// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"26":"map-view","114":"order-new","348":"chat","386":"order-detail"}[chunkId] + "." + {"26":"2104c0d3","114":"ff238b42","348":"064227c2","386":"ce435032"}[chunkId] + ".js";
};